export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      functionName: "見守り機能",
      locationNumber: "xxxxxx",
      nickName: "アイラ4号",
      answeredAt: 1234567890123,
      answer: "良いです",
      responseStatus: 3,
      responseNote: "note test"
    }
  }
}